const statuses = {
	default: 'default',
	readOnly: 'read-only',
	disabled: 'disabled',
	success: 'success',
	error: 'error',
};

export default statuses;
